import { Injectable } from '@angular/core';

@Injectable()
export class PrintService {
    constructor() { }

    public printFromId(elementId: string, title: string): void {
        let printContents, popupWin;
        printContents = document.getElementById(elementId).innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
        <html>
            <head>
              <title>Print ${title}</title>
            </head>
            <body id="printSection" onload="window.print();window.close()">${printContents}</body>
        </html>`
        );
        popupWin.document.close();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/print.service.ts